import { Form } from "@redriver/cinnamon";
import React from "react";
import { getContractPricingTypes } from "./actions";

const ContractPricingTypesDropdown = ({ ...props }) => (
  <Form.Dropdown lookupAction={getContractPricingTypes} {...props} />
);

export default ContractPricingTypesDropdown;
